<table
  mat-table
  [dataSource]="dataSource"
  class="mat-elevation-z2 stripped-table substatus-dates-table"
  [class.edit-mode]="editMode"
  >
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Substatus</th>
    <td mat-cell *matCellDef="let element">{{ element.status }}</td>
  </ng-container>
  <ng-container matColumnDef="subsequence">
    <th mat-header-cell *matHeaderCellDef>Subsequence</th>
    <td mat-cell *matCellDef="let element">{{ element.subsequence }}</td>
  </ng-container>
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef>Date</th>
    <td mat-cell *matCellDef="let element">
      <ng-container
        *ngTemplateOutlet="
          editMode ? editDate : element.date ? date : dash;
          context: {
            date: element.date,
            target: element.target,
            element: element
          }
        "
    ></ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="time">
  <th mat-header-cell *matHeaderCellDef>Time</th>
  <td mat-cell *matCellDef="let element">
      <ng-container *ngTemplateOutlet="editMode ? editTime : element.time ? time : dash; context: {
      element: element,
      time: element.time,
      timezone: element.timezone
      }">

    </ng-container>
  </td>

</ng-container>
<ng-container matColumnDef="target">
  <th mat-header-cell *matHeaderCellDef>Target</th>
  <td mat-cell *matCellDef="let element">
    @if (
      element.date?.length &&
      (!editMode || !element.subsequenceObj.permissions?._edit)
      ) {
      <date-target-indicator
        [target]="element.target"
        >
      </date-target-indicator>
    }
    @if (editMode && element.subsequenceObj.permissions?._edit) {
      <mat-checkbox
        (change)="queueTargetChange(element, $event)"
        [checked]="element.target"
        [disabled]="
          element.substatusDateObj?.date > today || element.date > today
        "
        >
      </mat-checkbox>
    }
  </td>
</ng-container>
<tr mat-header-row *matHeaderRowDef="columns"></tr>
<tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
<ng-template #editDate let-element="element">
  <sub-status-datepicker
    [subsequence]="element.subsequenceObj"
    [substatus]="element.substatusObj"
    [project_status_id]="project_status_id"
    [substatusDate]="element.substatusDateObj"
    (changeSubstatusDate)="changeSubstatusDate(element, $event)"
    [slim]="true"
    >
  </sub-status-datepicker>
</ng-template>
<ng-template #date let-date="date" let-target="target">
  {{ date | date: "MM/dd/yyyy" }}
</ng-template>
<ng-template #dash>&mdash;</ng-template>

<ng-template #editTime let-element="element">
  <sub-status-timepicker
    [substatusDate]="element.substatusDateObj ?? element"
    [project_status_id]="project_status_id"
    [subsequence]="element.subsequenceObj"
    [substatus]="element.substatusObj"
    (changeSubstatusDate)="changeSubstatusTime(element, $event)"
  ></sub-status-timepicker>
</ng-template>

<ng-template let-time="time" #time let-timezone="timezone">
  {{ formatTime(time, timezone) }}
</ng-template>
